import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";
import UserService from "../../services/user.service";

const RoleModal = (props) => {
  const { isSubmitting } = useState(false);
  const [checked, setChecked] = useState(props.user?.roles[0]?.roleName === "siteadmin");
  
  const modalClose = () => {
    props.closeModal(false);
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    UserService.setAdminRole(props.user.id, checked);
    props.closeModal(false);
  }
  const handleChange = async (e) => {
    if(e.target.checked) setChecked(true);
    else setChecked(false);
  }

  return (
    <Modal show={props.show} onHide={modalClose}>
    <Modal.Header closeButton>
      <Modal.Title>Update Roles<br/></Modal.Title>
    </Modal.Header>
    <Modal.Body>
        <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3" controlId="state">
                <Form.Check // prettier-ignore
                    type="switch"
                    id="role"
                    label="Is an Admin"
                    checked = {checked}
                    onChange={handleChange}
                />
              </Form.Group>
              <Modal.Footer>
                <Button variant="secondary" onClick={modalClose}>
                  Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Update Role
                </Button>
              </Modal.Footer>
            </Form>  
    </Modal.Body>
    </Modal>
  );
};

export default RoleModal; 